import { GenerateRafflePdf } from '@/app/utils/generateRafflePdf'
import { Button } from '@/view/components/ui/button'
import { useToast } from '@/view/components/ui/use-toast'
import { useEffect, useRef, useState } from 'react'
import { useParams } from 'react-router-dom'

export const DownloadRaffles = () => {
  const { raffleId, userId } = useParams()
  const hasDownloaded = useRef(false)
  const [isExporting, setIsExporting] = useState(true)
  const [status, setStatus] = useState<'pending' | 'error' | 'success'>(
    'pending',
  )
  const { toast } = useToast()

  const handleExport = async (rafffle: string, user: string) => {
    try {
      await GenerateRafflePdf({
        raffleId: rafffle,
        userId: user,
      })
      toast({
        title: 'PDF gerado com sucesso!',
      })
      setStatus('success')
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error: any) {
      console.error(error)
      toast({
        variant: 'destructive',
        title:
          error?.message ||
          'Erro ao carregador os dados, tente novamente mais tarde!',
      })
      setStatus('error')
    } finally {
      setIsExporting(false)
    }
  }

  useEffect(() => {
    if (raffleId && userId && !hasDownloaded.current) {
      hasDownloaded.current = true
      handleExport(raffleId, userId)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [raffleId, toast, userId])

  if (isExporting || status === 'pending') {
    return (
      <div className="flex h-screen w-full items-center justify-center">
        <p>Gerando seu PDF, aguarde um momento...</p>
      </div>
    )
  }
  if (status === 'success') {
    return (
      <div className="flex h-screen w-full flex-col items-center justify-center gap-4">
        <p className="text-center">Seu PDF foi baixado com sucesso.</p>
      </div>
    )
  }

  if (status === 'error') {
    return (
      <div className="flex h-screen w-full flex-col items-center justify-center gap-4">
        <p className="text-center">
          Ocorreu um erro ao gerar seu PDF
          <p>Tente novamente mais tarde.</p>
        </p>
        <Button
          className="p-5 font-bold"
          onClick={() => handleExport(raffleId as string, userId as string)}
        >
          Tentar novamente
        </Button>
      </div>
    )
  }
}
